import PropTypes from 'prop-types';
import styled from 'styled-components';

import ListCard from 'routes/Lists/components/ListCard';
import { contactListType } from 'common/typings';

const StyledListCard = styled(ListCard)`
  width: 100%;
  margin-top: 20px;
`;

const Lists = ({ isAddToGroupButtonDisabled, lists, onOpenAddToGroupModal }) =>
  lists.map(list => (
    <StyledListCard
      countAll={list.count}
      isAddToGroupButtonDisabled={isAddToGroupButtonDisabled}
      onOpenAddToGroupModal={onOpenAddToGroupModal}
      key={list.uuid}
      list={list}
    />
  ));

Lists.propTypes = {
  isAddToGroupButtonDisabled: PropTypes.bool.isRequired,
  lists: PropTypes.arrayOf(contactListType).isRequired,
  onOpenAddToGroupModal: PropTypes.func.isRequired,
};

export default Lists;
